export const SEARCH_NAME = "SEARCH_NAME"